import { useRef, useState } from "react";
import { cn } from "@/lib/utils";

// Apple-style 3D tilt card with dynamic shine.
export default function Glossy3DCard({ children, className, testid, onClick, tilt = true }) {
  const ref = useRef(null);
  const [style, setStyle] = useState({});
  const [shine, setShine] = useState({ x: 50, y: 0, o: 0 });

  const onMove = (e) => {
    if (!tilt || !ref.current) return;
    const r = ref.current.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width;
    const py = (e.clientY - r.top) / r.height;
    const rx = (0.5 - py) * 10;
    const ry = (px - 0.5) * 10;
    setStyle({ transform: `perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg) translateZ(6px)` });
    setShine({ x: px * 100, y: py * 100, o: 0.5 });
  };
  const onLeave = () => {
    setStyle({ transform: "perspective(900px) rotateX(0) rotateY(0) translateZ(0)" });
    setShine({ x: 50, y: 0, o: 0 });
  };

  return (
    <div
      ref={ref}
      data-testid={testid}
      onClick={onClick}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className={cn("glass relative rounded-3xl", tilt && "transition-transform duration-200 will-change-transform", className)}
      style={style}
    >
      <div
        className="pointer-events-none absolute inset-0 rounded-3xl transition-opacity duration-200"
        style={{
          opacity: shine.o,
          background: `radial-gradient(circle at ${shine.x}% ${shine.y}%, rgba(255,255,255,0.7), rgba(255,255,255,0) 55%)`,
        }}
      />
      {children}
    </div>
  );
}
